import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import TextButton from '@tds/core-text-button';

import request from '../../../../../utils/request';

const AddBan = ({ orderData, userRights }) => {
  const { canAssignOrder } = userRights;
  const { id, iotCurrentBan, iotTelusAccountNumber } = orderData;

  const [ban, setBan] = useState();
  const [changeBan, setChangeBan] = useState(false);
  const [updating, setUpdating] = useState(false);

  const updateBan = async () => {
    try {
      setChangeBan(false);
      setUpdating(true);
      const result = await request.put(`/orders/${id}`, {
        iotCurrentBan: ban,
        iotTelusAccountNumber: ban
      });
      if (result) {
        setUpdating(false);
      }
    } catch (error) {
      setUpdating(false);
    }
  };

  useEffect(() => {
    if (iotTelusAccountNumber) setBan(iotTelusAccountNumber);
    else if (iotCurrentBan) setBan(iotCurrentBan);
  }, []);

  return (
    <div style={{ padding: '0 0.75rem' }}>
      {updating ? (
        <p>Updating...</p>
      ) : (
        <>
          {changeBan ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                style={{ margin: '0.5rem 0', borderColor: '#222' }}
                type="text"
                placeholder="Add BAN..."
                value={ban}
                onChange={e => setBan(e.target.value)}
              />
              <div
                style={{
                  display: 'flex',
                  gap: '0.5rem',
                  marginLeft: '0.5rem',
                  alignItems: 'center'
                }}
              >
                <TextButton onClick={() => updateBan()}>Save</TextButton>
                <span>|</span>
                <TextButton
                  onClick={() => {
                    setBan(iotCurrentBan);
                    setChangeBan(false);
                  }}
                >
                  Cancel
                </TextButton>
              </div>
            </div>
          ) : (
            <div
              style={{ display: 'flex', alignItems: 'center', height: '100%' }}
            >
              <p style={{ marginRight: '1rem' }}>{ban || 'n/a'}</p>
              {canAssignOrder && (
                <TextButton onClick={() => setChangeBan(true)}>
                  Change
                </TextButton>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

AddBan.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default AddBan;
